<script lang="ts">
  import Toast from '../../components/ui/Toast.svelte';
  import type { ToastMessage } from '../../components/ui/toast-types.js';

  interface Props {
    messages: ToastMessage[];
    ondismiss: (id: string) => void;
  }

  let { messages, ondismiss }: Props = $props();
</script>

<Toast {messages} {ondismiss} />
